import { Checkbox, Space } from 'antd'
import { useVersionAwareDrilldownPanelData } from 'features/drilldown/data/DrilldownPanelDataContext'
import uniq from 'lodash/uniq'
import { FC, useCallback } from 'react'

import { CountsPanelData, useCountConfigs } from './DrilldownCountsView'

export const DrilldownCountsConfigView: FC = () => {
  const {
    panelData: { activeCountTypes },
    setPanelData,
  } = useVersionAwareDrilldownPanelData<CountsPanelData>()

  const handleCheck = useCallback(
    (countType: string, checked: boolean) => {
      setPanelData((prev) => {
        const newActiveCountTypes = checked
          ? uniq([...prev.activeCountTypes, countType])
          : prev.activeCountTypes.filter((t) => countType !== t)
        return {
          ...prev,
          activeCountTypes: newActiveCountTypes,
        }
      })
    },
    [setPanelData]
  )

  const options = useCountConfigs()

  return (
    <Space orientation='vertical' size='middle' style={{ width: '100%' }}>
      <Space orientation='vertical' size='small'>
        {Object.entries(options).map(([, countConfig]) => (
          <Checkbox
            key={countConfig.countType}
            checked={activeCountTypes.includes(countConfig.countType)}
            onChange={(e) =>
              handleCheck(countConfig.countType, e.target.checked)
            }>
            {countConfig.pluralTitle}
          </Checkbox>
        ))}
      </Space>
    </Space>
  )
}
